import React from 'react'
import TerraceBanner from './TerraceBanner'
import TerraceProduct from './TerraceProduct'

const Terrace = ({ quoteData }) => {
  return (
    <div>
      <TerraceBanner />
      <TerraceProduct quoteData={quoteData} />
    </div>
  )
}

export default Terrace